import Vue from 'vue';

/** Event bus for sending zone/office events. */
const ZonesEventBus = new Vue();

export default ZonesEventBus;
